var _defs, _line, _line2, _line3, _line4, _rect, _rect2, _line5, _rect3, _line6, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidedrawerWorkflowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.06 16.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".workflow-1{fill:#f26522;opacity:.15;}.workflow-2{fill:none;stroke:#f26522;stroke-miterlimit:10;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "workflow-2",
    x1: 6.82,
    y1: 2.07,
    x2: 1.51,
    y2: 2.07
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "workflow-2",
    x1: 15.54,
    y1: 2.07,
    x2: 10.26,
    y2: 2.07
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "workflow-2",
    x1: 15.04,
    y1: 2.57,
    x2: 15.04,
    y2: 9.14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "workflow-2",
    x1: 2.01,
    y1: 2.57,
    x2: 2.01,
    y2: 9.13
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-2",
    x: 0.5,
    y: 9.18,
    width: 3.15,
    height: 3.48,
    rx: 0.48,
    ry: 0.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-2",
    x: 13.41,
    y: 9.13,
    width: 3.15,
    height: 3.48,
    rx: 0.45,
    ry: 0.45
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "workflow-2",
    x1: 8.61,
    y1: 4.04,
    x2: 8.61,
    y2: 6.54
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-2",
    x: 6.98,
    y: 6.41,
    width: 3.15,
    height: 3.48,
    rx: 0.42,
    ry: 0.42
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "workflow-2",
    x1: 8.58,
    y1: 9.8,
    x2: 8.58,
    y2: 12.73
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-2",
    x: 6.95,
    y: 12.56,
    width: 3.15,
    height: 3.48,
    rx: 0.55,
    ry: 0.55
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-2",
    x: 6.95,
    y: 0.5,
    width: 3.15,
    height: 3.48,
    rx: 0.42,
    ry: 0.42
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-1",
    x: 7.32,
    y: 0.74,
    width: 2.47,
    height: 2.94
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-1",
    x: 0.82,
    y: 9.71,
    width: 2.47,
    height: 2.94
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-1",
    x: 7.5,
    y: 6.8,
    width: 2.47,
    height: 2.94
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-1",
    x: 13.61,
    y: 9.47,
    width: 2.47,
    height: 2.94
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "workflow-1",
    x: 7.2,
    y: 12.65,
    width: 2.47,
    height: 2.94
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidedrawerWorkflowIcon);
export default __webpack_public_path__ + "static/media/sidedrawer-workflow-icon.aa3de5dab3e858979a827d050cbd77b8.svg";
export { ForwardRef as ReactComponent };